
export function decimalTo(value, decimals = 2) {
  if (typeof value !== 'number') value = parseFloat(value);
  const factor = Math.pow(10, decimals);
  return Math.floor(value * factor) / factor;
}
